import React, { Component } from 'react';
import $ from 'jquery';

import Vas from '../../../Vas';

import '../../../css/CustomerContractDetails.css';

import { CurrencyConverter,DateTimeHelper } from 'utils-lib';

import { TextField,ExtendedButton } from 'component-lib';
import { RequestAjaxClass, ContractDetailsModel, ContractsModel } from 'models-lib';

var moment = require('moment');
        moment().format();

class CustomerContractDetails extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Edit = false;
        this.CustomerName = props.CustomerName;
        //this.CustomerId = localStorage.getItem('employee_id') ? localStorage.getItem('employee_id'): localStorage.getItem('vas_customerId');
        this.CustomerId = props.CustomerId;
        this.ContractId = props.Id;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.ContractDetailsModel = new ContractDetailsModel([this],null,this.Request);
        this.ContractsModel = new ContractsModel([this],null,this.Request);

        this.ContractsConfig = Vas.Config.Contracts;
      
    }

    componentDidMount(){
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      this.Request.setErrorHandler(()=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      })
      this.load();
      this.LogoClick();
    }

    componentWillMount(){
      this.LogoClick();
    }

    Update(observer)
    {
        let me = this;
        this.setState({},()=>{
          if(observer === "ContractDetails"){
            me.refs.TicketName.setState({ Value:me.ContractDetailsModel.Contract.TicketName });

            me.refs.ContractStart.setState({ Value: me.ContractDetailsModel.Contract.DateFrom
                                                    ?me.ContractDetailsModel.Contract.DateFrom
                                                    :'' });
            let from = DateTimeHelper.StringToDate( me.ContractDetailsModel.Contract.DateFrom,false,localStorage.getItem('vas_language'));
            let to = DateTimeHelper.StringToDate( me.ContractDetailsModel.Contract.DateTo,false,localStorage.getItem('vas_language'));
            me.refs.ContractEnd.setState({ Value: to.isBefore(from)
                                                    ? "" 
                                                    : me.ContractDetailsModel.Contract.DateTo });
            
            //Hier die Bezeichnung des Status anpassen
            //Neu an dieser Stelle Status Gekündigt (Beachte Darstellung Umpaut ü)
            switch(me.ContractDetailsModel.Contract.StatusId){
              case 2:
                me.refs.State.setState({ Value:Vas.Resources.Labels["Canceled"] });
              break;

              case 10:
                me.refs.State.setState({ Value:Vas.Resources.Labels["PendingApproval"] });
              break;

              default:
                me.refs.State.setState({ Value:me.ContractDetailsModel.Contract.Status?me.ContractDetailsModel.Contract.Status:'' }); 
              break;
            }
            
            me.refs.ContractNumber.setState({ Value: me.ContractDetailsModel.Contract.ContractNumber?me.ContractDetailsModel.Contract.ContractNumber:'' });
            me.refs.NameOfBank.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.BankName : "" });
            me.refs.Iban.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.Iban: "" });
            me.refs.Bic.setState({ Value:me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.Bic : "" });
            me.refs.Depositor.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.AccountOwner : "" });
            me.refs.From.setState({ Value: me.ContractDetailsModel.ContractConnection.From?me.ContractDetailsModel.ContractConnection.From:'' });
            me.refs.To.setState({ Value: me.ContractDetailsModel.ContractConnection.To?me.ContractDetailsModel.ContractConnection.To:'' });
            me.refs.Via.setState({ Value: me.ContractDetailsModel.ContractConnection.Via?me.ContractDetailsModel.ContractConnection.Via:'' });
            me.refs.ProductPrice.setState({ Value: CurrencyConverter.Cast( me.ContractDetailsModel.ContractPrice.Price, localStorage.getItem("vas_language") ,2)
                                                    ? CurrencyConverter.Cast( me.ContractDetailsModel.ContractPrice.Price, localStorage.getItem("vas_language") ,2)
                                                    :'' });
            me.refs.PriceLevel.setState({ Value: me.ContractDetailsModel.ContractPrice.PriceLevel });
            me.refs.Share1.setState({ Value:me.ContractDetailsModel.Share1 !== null ?me.ContractDetailsModel.Share1:'' });
            me.refs.Share2.setState({ Value:me.ContractDetailsModel.Share2 !== null ?me.ContractDetailsModel.Share2:'' });
            
            me.setState({ FlagLoss : me.ContractDetailsModel.FlagLoss, StatusId:me.ContractDetailsModel.Contract.StatusId });
            $("#LoadingIcon").removeClass().addClass('hide');

            this.LogoClick();
          }else if(observer === "ContractsChange"){
            Vas.GetView("Contract", { Id: this.ContractId, CustomerId: this.CustomerId, CustomerName:this.CustomerName }, true);
          }

          this.LogoClick();
        });
    }

    load(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.ContractDetailsModel.GetContractDetailsByContractId(this.props.Id);

        this.LogoClick();
    }

    contractEdit(){
        /*ReactDOM.render(<OrderContract
          id={this.CustomerId}
          reference={this}
          contract={this.state.Contract}  />, document.getElementById('popupContainer'));*/
          Vas.GetView('Order', {CustomerId:this.CustomerId, ContractId:this.props.Id}, true);
    }

    contractCancel(){
      localStorage.setItem('contract',JSON.stringify(this.ContractDetailsModel.Contract));
      Vas.GetView('ContractCancel',null,true);
    }

    contractApprove(){
      this.ContractsModel.ContractsChangeStatus(this.ContractId,"",true,false);
    }

    contractDecline(){
      Vas.GetView('ContractEditState', {CustomerId : this.CustomerId, ContractId: this.ContractId, CustomerName : this.CustomerName}, true);
    }

    LogoClick(){
      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){

        $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #1d5c87; border-bottom: 5px solid #1d5c87; z-index: 1;');
        $('.contractDetailsForm').attr('style', 'border: 1px solid #1d5c87;');

        $('#btoContractChange').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('#btoContractCancel').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('.extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('.contractDetailsForm .extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');

        $("#root").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
      }
    }

    render()
    {
      this.LogoClick();
      var kontrastNumber = localStorage.getItem('Kontrast');

        let button = <td></td>;

        var jobTicketIdents = "01-78-02, 01-79-02, 01-80-02, 01-81-02, 01-82-02, 01-83-02, 01-84-02, 01-85-02, 01-86-02, 01-87-02, 01-88-02, 01-89-02, 01-90-02, 01-91-02, 01-92-02, 01-93-02, 01-94-02, 01-96-02, 01-961-02";

        if(localStorage.getItem('vas_role') === "1" && jobTicketIdents.indexOf(this.ContractDetailsModel.Contract.TicketIdent) > -1) {
          button = <td></td>;
        } else {
            if (this.state.StatusId){
              if (this.state.StatusId === 1){
                if(kontrastNumber == "true"){
                  button =(<td>
                    <div className={"contractChangeLeftContainer"}><ExtendedButton
                      Id={"btoContractChange"}
                      Usable={true}
                      Text={Vas.Resources.Labels["ContractChange"]}
                      Float={"right"}
                      Width={120}
                      BackgroundColor={"#1d5c87"}
                      OnClick={()=>{this.contractEdit();}} /></div>
                    <div className={"contractCancelRightContainer"}><ExtendedButton
                      Id={"btoContractCancel"}
                      Usable={true}
                      Text={Vas.Resources.Labels["ContractCancel"]}
                      Float={"right"}
                      Width={120}
                      BackgroundColor={"#1d5c87"}
                      OnClick={()=>{this.contractCancel();}} /><br /></div>
                  </td>);
                } else{
                  button =(<td>
                    <div className={"contractChangeLeftContainer"}><ExtendedButton
                      Id={"btoContractChange"}
                      Usable={true}
                      Text={Vas.Resources.Labels["ContractChange"]}
                      Float={"right"}
                      Width={120}
                      BackgroundColor={"#3393d3"}
                      OnClick={()=>{this.contractEdit();}} /></div>
                    <div className={"contractCancelRightContainer"}><ExtendedButton
                      Id={"btoContractCancel"}
                      Usable={true}
                      Text={Vas.Resources.Labels["ContractCancel"]}
                      Float={"right"}
                      Width={120}
                      BackgroundColor={"#3393d3"}
                      OnClick={()=>{this.contractCancel();}} /><br /></div>
                  </td>);
                }
              }
              else if(this.state.StatusId === 10){
                if(localStorage.getItem('vas_role') === "3"){
                  if(this.ContractsConfig.AllowApproveDisline === true){
                    button =(<td>
                      <div className={"contractChangeLeftContainer"}><ExtendedButton
                        Id={"btoApprove"}
                        Usable={true}
                        Text={Vas.Resources.Labels["Approve"]}
                        Float={"right"}
                        Width={120}
                        OnClick={()=>{this.contractApprove();}} /></div>
                      <div className={"contractCancelRightContainer"}><ExtendedButton
                        Id={"btoDecline"}
                        Usable={true}
                        Text={Vas.Resources.Labels["Decline"]}
                        Float={"right"}
                        Width={120}
                        OnClick={()=>{this.contractDecline();}} /><br /></div>
                    </td>) ;
                  }
                }
              }
          }
        }

        this.LogoClick();

        return (<div style={{ marginTop:10, marginLeft:10 }}>
          <table >
            <thead>
              <tr>
                <td className={"emptyColumn"}></td>
                {button}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["ContractData"]}</b></td>
              </tr>
              <tr>
                <td className={"LeftContainer"}><TextField
                  Id={"contractNumber"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"ContractNumber"}
                  Label={Vas.Resources.Labels["ContractNumber"]}
                  Editable={false} /></td>
                <td className={"RightContainer"}><TextField
                  Id={"productPrice"}
                  Label={Vas.Resources.Labels["ProductPrice"]}
                  ref={"ProductPrice"}
                  Editable={false} /></td>
              </tr>
              <tr>
                <td className={"LeftContainer"}><TextField
                  Id={"priceLevel"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"PriceLevel"}
                  Label={Vas.Resources.Labels["PriceLevel"]}
                  Editable={false} /></td>
                <td className={"RightContainer"}><TextField
                  Id={"state"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"State"}
                  Label={Vas.Resources.Labels["State"]}
                  Editable={false} /> </td>
              </tr>
              <tr>
                <td className={"LeftContainer"}><TextField
                  Id={"contractStart"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"ContractStart"}
                  Label={Vas.Resources.Labels["ContractStart"]}
                  Editable={false} /></td>
                <td className={"RightContainer"}><TextField
                  Id={"contractEnd"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"ContractEnd"}
                  Label={Vas.Resources.Labels["ContractEnd"]}
                  Editable={false} /></td>
              </tr>
              <tr>
                <td className={"LeftContainer"}><TextField
                  Id={"share1"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"Share1"}
                  Label={Vas.Resources.Labels["Share1"]}
                  Editable={false} /></td>
                <td className={"RightContainer"}><TextField
                  Id={"share2"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"Share2"}
                  Label={Vas.Resources.Labels["Share2"]}
                  Editable={false} /></td>
              </tr>
              <tr>
                <td><TextField
                  Id={"ticketName"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"TicketName"}
                  Label={Vas.Resources.Labels["TicketName"]}
                  Editable={false} /></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <br />
          <table>
            <tbody>
              <tr><td
                colSpan={2}
                className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["ConnectionData"]}</b></td></tr>
              <tr>
                <td className={"LeftContainer"}><TextField
                  Id={"from"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"From"}
                  Label={Vas.Resources.Labels["From"]}
                  Editable={false} /></td>
                <td className={"RightContainer"}><TextField
                  Id={"to"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"To"}
                  Label={Vas.Resources.Labels["To"]}
                  Editable={false} /> </td>
              </tr>
              <tr>
                <td><TextField
                  Id={"via"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"Via"}
                  Label={Vas.Resources.Labels["Via"]}
                  Editable={false} /></td>
              </tr>
            </tbody>
          </table>
          <br />
          <table >
            <tbody>
              <tr><td
                colSpan={2}
                className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["MethodOfPaymentCustomer"]}</b></td></tr>
              <tr>
                <td colSpan={2}><TextField
                  Id={"depositor"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"Depositor"}
                  Label={Vas.Resources.Labels["Depositor"]}
                  Width={346}
                  Editable={false} /></td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <TextField
                    Id={"nameOfBank"}
                    AppURL={Vas.ApplicationUrl}
                    ref={"NameOfBank"}
                    Label={Vas.Resources.Labels["NameOfBank"]}
                    Width={346}
                    Editable={false} />
                </td>
              </tr>
              <tr>
                <td className={"LeftContainer"}><TextField
                  Id={"iban"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"Iban"}
                  Label={Vas.Resources.Labels["Iban"]}
                  Editable={false} /> </td>
                <td className={"RightContainer"}><TextField
                  Id={"bic"}
                  AppURL={Vas.ApplicationUrl}
                  ref={"Bic"}
                  Label={Vas.Resources.Labels["Bic"]}
                  Editable={false} /></td>
              </tr>
            </tbody>
          </table>
        </div>);
    }
}
export default CustomerContractDetails;
